import * as yup from "yup";

/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import AutoComplete from "../../../../components/hookForms/autoComplete";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import messages from "../../../../utils/messages";
import serviceFaturaInstalacao from "../../../../services/serviceFaturaInstalacao";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Loader } from "./styles";
export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    onClose?: any;
    data: {
        idFaturaPrevista: string;
        numeroInstalacao: string;
        ciclo: string;
        regraFatura: string;
    };
}

const schema = yup.object().shape({
    regraFatura: yup.string().required(messages.requiredField),
});

export default function DialogFaturarPrevisto({ open, onClose, data, onSuccess }: IDialogProps) {
    const [isDisable, setDisable] = useState(false);

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });

    useEffect(() => {
        if (data) {
            reset(data);
        }
    }, [data]);

    const regraFaturaOptions = [
        { label: "Fatura Prevista Injetado", value: "Fatura Prevista Injetado" },
        { label: "Fatura Prevista Consumo", value: "Fatura Prevista Consumo" },
    ];

    const onSubmit = (values: any) => {
        setDisable(true);

        const faturarPrevistoValues = {
            idFaturaPrevista: data.idFaturaPrevista,
            regraFatura: values.regraFatura,
        };

        serviceFaturaInstalacao
            .createByFaturaPrevista(faturarPrevistoValues)
            .then((result) => {
                if (result) {
                    toast.success("Fatura de Instalação gerada com sucesso. ID: " + result.data.faturaInstalacaoID);
                    onClose(true);
                    onSuccess();
                }
            })
            .catch((error) => {
                toast.error("Ocorreu um erro ao gerar a Fatura de Instalação para Fatura Prevista selecionada", error);
            })
            .finally(() => {
                setDisable(false);
            });
    };

    return (
        <>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    Faturar pelo previsto
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose(true);
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent dividers>
                        <Box>
                            <Grid item xs={12}>
                                {isDisable && (
                                    <Loader>
                                        <img alt="Loading" src="/Loading.gif" width="40px" height="40px" />
                                    </Loader>
                                )}
                            </Grid>
                            <Typography variant="subtitle1">Fatura Prevista ID: {data.idFaturaPrevista}</Typography>
                            <Typography variant="subtitle1">Instalação: {data.numeroInstalacao}</Typography>
                            <Typography variant="subtitle1">Ciclo: {data.ciclo}</Typography>
                            <Grid container spacing={1}>
                                <Grid item xs={12} md={12}>
                                    <AutoComplete
                                        name="regraFatura"
                                        label="Tipo de Regra"
                                        options={regraFaturaOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button
                            onClick={onClose}
                            color="warning"
                            variant="contained"
                            style={{ width: "159px", height: "44px" }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            type="submit"
                            color="primary"
                            variant="contained"
                            disabled={isDisable}
                            style={{ width: "159px", height: "44px" }}
                        >
                            Confirmar
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}
